import { RootState } from '../reducers';

export const getDocsLoaded = (state: RootState) => state.loaded;
